import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../css/BaseElementsCSS/BaseElementsDesktop.css';
function StepInfos ({stepInfos}){

    return <div className='baseElementsSquare baseElementsTobBarElementsText'>
       {stepInfos}</div>
}
export default StepInfos;